import { RedirectedFromCaRoutes } from '../constants/redirected-from-ca-routes.enum';
import { AppScope } from '../constants/app-scope.enum';

export const getAppScope = (firstPageRoute: string) => {
  if ((Object.values(RedirectedFromCaRoutes) as string[]).includes(firstPageRoute)) {
    return AppScope.CA;
  }

  return AppScope.Default;
};
